module.exports = __webpack_public_path__ + "images/artist_90.6376ff4e3ae93bf01cfc55f1709c1893.png";